export const clearSecretIndication = (secretValue?: string | boolean) =>
  typeof secretValue === 'boolean' ? undefined : secretValue;
